import '../../src/js/components/_1_swipe-content.js';
import '../../src/js/components/_2_carousel.js';

const initTestimonialSliders = () => {
  document.querySelectorAll('.testimonial-slider__carousel').forEach((carousel) => {
    if (carousel.dataset.testimonialInitialized === 'true') return;

    const gestureSurface = carousel.querySelector('.testimonial-slider__gesture-surface');
    const getNavigationItems = () => Array.from(carousel.querySelectorAll('.js-carousel__nav-item'));
    const getSelectedIndex = (items) => items.findIndex((item) => item.classList.contains('carousel__nav-item--selected'));
    const selectRelativeItem = (direction) => {
      const items = getNavigationItems();
      if (items.length < 2) return;

      const selectedIndex = getSelectedIndex(items);
      const nextIndex = (selectedIndex + direction + items.length) % items.length;
      items[nextIndex].querySelector('button')?.click();
    };

    if (gestureSurface && carousel.dataset.testimonialDrag === 'on' && window.SwipeContent) {
      new window.SwipeContent(gestureSurface);
      gestureSurface.addEventListener('swipeLeft', () => selectRelativeItem(1));
      gestureSurface.addEventListener('swipeRight', () => selectRelativeItem(-1));
    }

    if (carousel.dataset.testimonialAutoplay === 'on') {
      const interval = Number.parseInt(carousel.dataset.autoplayInterval, 10) || 6000;
      let autoplayId;
      const startAutoplay = () => {
        window.clearInterval(autoplayId);
        autoplayId = window.setInterval(() => selectRelativeItem(1), interval);
      };
      const stopAutoplay = () => window.clearInterval(autoplayId);

      carousel.addEventListener('mouseenter', stopAutoplay);
      carousel.addEventListener('mouseleave', startAutoplay);
      carousel.addEventListener('focusin', stopAutoplay);
      carousel.addEventListener('focusout', startAutoplay);
      startAutoplay();
    }

    carousel.dataset.testimonialInitialized = 'true';
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTestimonialSliders);
} else {
  initTestimonialSliders();
}
